export const RENT_BOOKING_ROUTE_NAMES = {
    APP: "RentBooking",
};
